export const ANALYST_RUNS_PATH = "/analyst-runs";

export const ANALYST_RUNS_FINDING_PATH = `${ANALYST_RUNS_PATH}/finding/:id`;

export const ANALYST_RUNS_FINDING_MEMBER_PATH = `${ANALYST_RUNS_FINDING_PATH}/member`;

export const ANALYST_DETAILS_PANE_PATH = `${ANALYST_RUNS_PATH}/analyst/:agentInstanceId/automations`;

export const ANALYST_AUTOMATION_WIZARD_CREATE_PATH = `${ANALYST_DETAILS_PANE_PATH}/new`;

export const ANALYST_AUTOMATION_WIZARD_EDIT_PATH = `${ANALYST_DETAILS_PANE_PATH}/:automationId/edit`;

export const buildAnalystRunsFindingPath = (
  findingId: string,
  isGroupMember: boolean
): string =>
  `${ANALYST_RUNS_PATH}/finding/${findingId}${isGroupMember ? "/member" : ""}`;

export const buildAnalystDetailsPanePath = (agentInstanceId: string): string =>
  `${ANALYST_RUNS_PATH}/analyst/${agentInstanceId}/automations`;

export const buildAnalystAutomationWizardPath = (
  agentInstanceId: string,
  automationId?: string
): string => {
  const base = buildAnalystDetailsPanePath(agentInstanceId);
  return automationId ? `${base}/${automationId}/edit` : `${base}/new`;
};

export const withAnalystRunsSearch = (
  pathname: string,
  search?: string
): string => {
  if (!search) {
    return pathname;
  }
  return `${pathname}${search.startsWith("?") ? search : `?${search}`}`;
};
